import { useState, useEffect } from "react";
import { debounce } from "lodash-es";

export const useWindowDimensions = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = debounce(() => {
      if (height !== window.innerHeight) {
        setHeight(window.innerHeight);
      }
      if (width !== window.innerWidth) {
        setWidth(window.innerWidth);
      }
    }, 500);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { height, width };
};
